import { render, staticRenderFns } from "./PagesSegmentation.vue?vue&type=template&id=0aa1feb0&scoped=true&"
import script from "./PagesSegmentation.vue?vue&type=script&lang=js&"
export * from "./PagesSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./PagesSegmentation.vue?vue&type=style&index=0&id=0aa1feb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1feb0",
  null
  
)

export default component.exports